import { Box, Button, Grid, Typography } from '@mui/material';
import React from 'react';
import AttachFileSharpIcon from '@mui/icons-material/AttachFileSharp';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  download: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export default function KenUploadButton(props) {
  const classes = useStyles();
  const { open, recordId, handleDownload, fileType, fileName } = props;
  return (
    // <div style={{ border: "1px dashed #092682", borderRadius: 6 }}>
    <React.Fragment>
      {!recordId ? (
        <Button
          variant="secondary"
          onClick={open}
          startIcon={<AttachFileSharpIcon style={{ color: '#092682' }} />}
          style={{
            color: '#092682',
            border: '1px dashed #092682',
            borderRadius: 6,
            width: '100%',
          }}
        >
          Choose or Drag file
        </Button>
      ) : (
        <Box>
          <Grid container spacing={2} alignItems="center">
            <Grid item md={5}>
              <Typography
                //   startIcon={<AttachFileSharpIcon style={{ color: '#092682' }} />}
                style={{
                  color: '#ffffff',
                  fontSize: 14,
                  opacity: '0.6',
                  borderRadius: 6,
                  width: '100%',
                  background: '#008000',
                  textTransform: 'uppercase',
                  padding: '12px 0px',
                  textAlign: 'center'
                }}
              >
                Submitted
              </Typography>
            </Grid>
            <Grid item md={2}>
              <FileDownloadIcon
                sx={{ marginTop: '6px' }}
                className={classes.download}
                onClick={() => {
                  handleDownload(recordId, fileType, fileName);
                }}
              />
            </Grid>
            <Grid item md={5}>
              <Button
                variant="secondary"
                onClick={open}
                //   startIcon={<AttachFileSharpIcon style={{ color: '#092682' }} />}
                style={{
                  color: '#092682',
                  border: '1px dashed #092682',
                  borderRadius: 6,
                  width: '100%',
                }}
              >
                ReUpload
              </Button>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item md={12} textAlign="left">
              <Typography
                align="left"
                variant="subtitle2"
                sx={{
                  marginBottom: '-20px',
                  marginTop: '8px',
                  color: '#7A869A',
                }}
              >
                {fileName}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      )}
    </React.Fragment>
    // </div>
  );
}